import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { ThemeProvider } from '../theme/ThemeProvider'
import { useMe } from '../api/queries'
import { ApiError } from '../api/http'
import { router } from './router'

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000, refetchOnWindowFocus: false } } })

/** Loads the session once (it carries the CSRF token for writes), then the app. */
function SessionGate() {
  const me = useMe()
  if (me.isPending) return <div className="page t-muted" role="status">Loading your workspace…</div>
  if (me.isError && me.error instanceof ApiError && me.error.status === 401) return <div className="page"><div className="alert"><b>Sign in to PropAlpha</b><p>Your account keeps your collections, settings and saved results together.</p><a className="btn is-primary" href="/login">Sign in</a></div></div>
  if (me.isError) return <div className="page"><div className="alert"><b>Workspace unavailable</b><p>{me.error.message}</p><button className="btn" type="button" onClick={() => void me.refetch()}>Try again</button></div></div>
  return <RouterProvider router={router} />
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <SessionGate />
      </ThemeProvider>
    </QueryClientProvider>
  )
}
